import { useLiveQuery } from "@tanstack/react-db";
import { useContext, useEffect, useState } from "react";

import { FeedContext } from "@/models/FeedContextProvider";
import { fetchFeedCommandAliasesQuery } from "@/models/repositories";
import DriverCentricFeed from "./driver-centric/DriverCentricFeed";

export default function Feed() {
  const { currentFeed } = useContext(FeedContext);
  const [currentFeedDate, setCurrentFeedDate] = useState<Date | null>(null);

  useEffect(() => {
    setCurrentFeedDate(() => new Date());
  }, [currentFeed?.id]);

  const { data: aliasChannelRows } = useLiveQuery((q) =>
    currentFeed?.id ? fetchFeedCommandAliasesQuery(currentFeed.id)(q) : null,
  );
  const aliasChannelDetails = aliasChannelRows ?? [];

  const aliasAccount = aliasChannelDetails?.length > 0 ? aliasChannelDetails[0] : null;

  return <DriverCentricFeed currentFeedDate={currentFeedDate} aliasAccount={aliasAccount} feed={currentFeed} />;
}
